import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M566-80v-60h214v-430H180v220h-60v-470h125v-60h65v60h340v-60h65v60h125v740H566ZM320-14l-42-42 113-114H50v-60h341L278-344l42-42 186 186L320-14Z"
  })
}), "EventUpcomingFilled");